<template>
    <div>
        <!-- <div id="main"></div> -->
        <vue-echarts id="chart5DimFollowProb" :option="option" ref="chart" class="chart" autoResize />
    </div>
</template>

<script>
import { VueEcharts } from "vue3-echarts";

export default {
    name: 'horStackBarChart',
    data() {
        return {
        }
    },
    components: {
        VueEcharts,
    },
    props: {
        DimFollow: Object,
        // prefixAmount: String,
    },
    methods: {
        globalNumDecFixed(num, dec_amount) {
            var new_num = Number(num);
            const have_decimal = num % 1;
            const one_decimal = Math.round(num * 10) / 10;
            if (!have_decimal) {
                dec_amount = 0;
            }
            else if (have_decimal == one_decimal) {
                dec_amount = 1;
            }
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: dec_amount,
            }).format(new_num.toFixed(dec_amount));
        },
        millionShortNum(num) {
            if (num >= 1000000000000000000000000) {
                return this.globalNumDecFixed(
                    (num / 1000000000000000000000000).toFixed(2).replace(/\.0$/, ""),
                    1
                );
            }
            if (num >= 1000000000000000000) {
                return this.globalNumDecFixed(
                    (num / 1000000000000000000).toFixed(2).replace(/\.0$/, ""),
                    1
                );
            }
            if (num >= 1000000000000) {
                return this.globalNumDecFixed((num / 1000000000000)
                    .toFixed(2)
                    .replace(/\.0$/, ""), 1);
            }
            if (num >= 1000000) {
                return this.globalNumDecFixed((num / 1000000)
                    .toFixed(2)
                    .replace(/\.0$/, ""), 1);
            }
            return this.globalNumDecFixed(num.toFixed(2).replace(/\.0$/, ""), 2);
        },
        millionShortString(num) {
            if (num >= 1000000000000000000000000) {
                return "ล้านล้านล้านล้าน";
            }
            if (num >= 1000000000000000000) {
                return "ล้านล้านล้าน";
            }
            if (num >= 1000000000000) {
                return "ล้านล้าน";
            }
            if (num >= 1000000) {
                return "ล้าน";
            }
            return '';
        }
    },
    mounted() {
        // setTimeout(function () {
        //     this.$nextTick(() => {
        //         this.$refs.chart.setOption(
        //             {
        //                 legend: {
        //                     show: false
        //                 }
        //             }
        //         );
        //     })
        // }.bind(this), 350)

        this.option.series[0].data = [
          this.DimFollow.youngchild.planned,
          this.DimFollow.child.planned,
          this.DimFollow.adolescence.planned,
          this.DimFollow.adult.planned,
          this.DimFollow.elderly.planned
        ];
        this.option.series[1].data = [
          this.DimFollow.youngchild.helped,
          this.DimFollow.child.helped,
          this.DimFollow.adolescence.helped,
          this.DimFollow.adult.helped,
          this.DimFollow.elderly.helped
        ];
        this.option.series[2].data = [
          this.DimFollow.youngchild.closed,
          this.DimFollow.child.closed,
          this.DimFollow.adolescence.closed,
          this.DimFollow.adult.closed,
          this.DimFollow.elderly.closed
        ];
        this.option.series[3].data = [
          this.DimFollow.youngchild.not_proceeded,
          this.DimFollow.child.not_proceeded,
          this.DimFollow.adolescence.not_proceeded,
          this.DimFollow.adult.not_proceeded,
          this.DimFollow.elderly.not_proceeded
        ];

        this.$refs.chart.setOption(this.option);
    },
    // watch: {
    //     DimFollow(newData, oldData) {
    //         console.log('newData watch!!')
    //         this.$nextTick(() => {
    //             this.$refs.chart.setOption({
    //                 series: [
    //                 {
    //                     name: 'วางแผนแล้ว',
    //                     type: 'bar',
    //                     stack: 'total',
    //                     emphasis: {
    //                         focus: 'series'
    //                     },
    //                     silent: true,
    //                     data: [newData.youngchild.planned,
    //                     newData.child.planned,
    //                     newData.adolescence.planned,
    //                     newData.adult.planned,
    //                     newData.elderly.planned]
    //                 },
    //                 {
    //                     name: 'ดำเนินการแล้ว',
    //                     type: 'bar',
    //                     stack: 'total',
    //                     emphasis: {
    //                         focus: 'series'
    //                     },
    //                     silent: true,
    //                     data: [newData.youngchild.helped,
    //                     newData.child.helped,
    //                     newData.adolescence.helped,
    //                     newData.adult.helped,
    //                     newData.elderly.helped]
    //                 },
    //                 {
    //                     name: 'ยุติแล้ว',
    //                     type: 'bar',
    //                     stack: 'total',
    //                     emphasis: {
    //                         focus: 'series'
    //                     },
    //                     silent: true,
    //                     data: [newData.youngchild.closed,
    //                     newData.child.closed,
    //                     newData.adolescence.closed,
    //                     newData.adult.closed,
    //                     newData.elderly.closed]
    //                 },
    //                 {
    //                     name: 'ยังไม่ดำเนินการ',
    //                     type: 'bar',
    //                     stack: 'total',
    //                     emphasis: {
    //                         focus: 'series'
    //                     },
    //                     silent: true,
    //                     data: [newData.youngchild.not_proceeded,
    //                     newData.child.not_proceeded,
    //                     newData.adolescence.not_proceeded,
    //                     newData.adult.not_proceeded,
    //                     newData.elderly.not_proceeded]
    //                 },
    //             ]
    //             }
    //
    //             );
    //         })
    //     }
    // },
    computed: {
        option() {
            const vm = this;
            return {
                tooltip: {
                    name: false,
                    trigger: 'axis',
                    confine: 'true',
                    axisPointer: {
                        // Use axis to trigger tooltip
                        type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                    },
                    textStyle: {
                        fontWeight: '400',
                    },
                    valueFormatter: (value) => this.globalNumDecFixed(value) + ' คน',
                    triggerOn: 'mousemove|click',
                    order: 'seriesAsc'
                },
                legend: {
                    show: false
                },
                textStyle: {
                    fontFamily: 'kanit',
                    fontWeight: '300',
                    fontSize: '10px'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    top: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    axisLabel: {
                        show: false,
                        formatter: function (value, index) {
                            return vm.millionShortNum(value);
                        }
                    },
                },
                yAxis: {
                    type: 'category',
                    data: ['เด็กเล็ก', 'เด็ก', 'เยาวชน', 'วัยผู้ใหญ่', 'ผู้สูงอายุ'],
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#728196'
                        }
                    },
                    inverse: true
                },
                color: ["#f7751a",
                    "#f49d0d",
                    "#129287",
                    "#e2e8f0"],
                series: [
                    {
                        name: 'วางแผนแล้ว',
                        type: 'bar',
                        stack: 'total',
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: [this.DimFollow.youngchild.planned,
                        this.DimFollow.child.planned,
                        this.DimFollow.adolescence.planned,
                        this.DimFollow.adult.planned,
                        this.DimFollow.elderly.planned]
                    },
                    {
                        name: 'ดำเนินการแล้ว',
                        type: 'bar',
                        stack: 'total',
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: [this.DimFollow.youngchild.helped,
                        this.DimFollow.child.helped,
                        this.DimFollow.adolescence.helped,
                        this.DimFollow.adult.helped,
                        this.DimFollow.elderly.helped]
                    },
                    {
                        name: 'ยุติแล้ว',
                        type: 'bar',
                        stack: 'total',
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: [this.DimFollow.youngchild.closed,
                        this.DimFollow.child.closed,
                        this.DimFollow.adolescence.closed,
                        this.DimFollow.adult.closed,
                        this.DimFollow.elderly.closed]
                    },
                    {
                        name: 'ยังไม่ดำเนินการ',
                        type: 'bar',
                        stack: 'total',
                        emphasis: {
                            focus: 'series'
                        },
                        silent: true,
                        data: [this.DimFollow.youngchild.not_proceeded,
                        this.DimFollow.child.not_proceeded,
                        this.DimFollow.adolescence.not_proceeded,
                        this.DimFollow.adult.not_proceeded,
                        this.DimFollow.elderly.not_proceeded]
                    },
                ]
            }
        },
    },
};
</script>

<style scoped>
.chart {
    top: 0px;
    max-height: 180px;
    height: 180px;
}

@media screen and (max-width: 1199.8px) {
    .chart {
        max-height: 150px;
        height: 150px;
    }
}
</style>
